import { Box, Button, Typography } from "@mui/material";
import React from "react";

const DataMigrationSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#fbc521",
        py: 6,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
        boxSizing: "border-box"
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontFamily: "'Spline_Sans_Mono-SemiBold', Helvetica",
          fontWeight: 600,
          color: "#060505",
          fontSize: { xs: "32px", md: "49px" },
          lineHeight: { xs: "40px", md: "58.8px" },
          mb: 3,
          maxWidth: "1296px",
        }}
      >
        Welcome to our secure data transfer service
      </Typography>

      <Typography
        variant="body1"
        sx={{
          fontFamily: "'Space_Grotesk-Medium', Helvetica",
          fontWeight: 500,
          color: "#6f581b",
          fontSize: "18px",
          lineHeight: "27px",
          mb: 5,
          maxWidth: "558px",
        }}
      >
        Seamlessly migrate your files with our top-notch security and 24/7
        support. Enjoy the flexibility to access your data anytime, anywhere
      </Typography>

      <Button
        variant="contained"
        sx={{
          bgcolor: "#030202",
          color: "#d0d0c8",
          borderRadius: "54px",
          textTransform: "none",
          fontFamily: "'Inter-Regular', Helvetica",
          fontSize: "15px",
          py: 2,
          px: 4,
          minWidth: "245px",
          "&:hover": {
            bgcolor: "#1a1a1a",
          },
        }}
        onClick={() => {
            const section = document.getElementById("services-section");
            if (section) {
              section.scrollIntoView({ behavior: "smooth" });
            }
          }}
      >
        Explore Our Services
      </Button>
    </Box>
  );
};

export default DataMigrationSection;